/**
 * getInitials — always returns TWO uppercase letters for profile avatars.
 * Rules:
 *   - Multi-word names → first letter of first + first letter of last word
 *     (e.g., "Kevin Pay Pay" → "KP")
 *   - Single-word names → first two letters of the word (e.g., "Carlos" → "CA")
 *   - Email-only fallback → first two letters of the local part
 *     (e.g., "kpay@nobleempirecs.com" → "KP")
 *   - Empty / undefined → "NE" (Noble Empire default)
 *
 * Used by EVERY profile avatar across NECS company structures so the
 * navbar chip stays visually consistent for tenants, PMs, agents, and
 * NECS admins alike.
 */
export function getInitials(input) {
  const raw = (input || '').trim();
  if (!raw) return 'NE';

  // If it's an email, drop the domain before splitting.
  const source = raw.includes('@') ? raw.split('@')[0] : raw;

  const parts = source.split(/[\s._-]+/).filter(Boolean);
  if (parts.length === 0) return 'NE';

  if (parts.length === 1) {
    // Take the first two letters of the single token so we always get 2 chars.
    return (parts[0].slice(0, 2) || 'NE').toUpperCase();
  }

  const first = parts[0][0] || '';
  const last = parts[parts.length - 1][0] || '';
  const both = (first + last).toUpperCase();
  return both.length === 2 ? both : (parts[0].slice(0, 2) || 'NE').toUpperCase();
}
